import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import styled from "styled-components/macro"
import Header from "./header"
import "./layout.css"
import { HeaderTitle, HeaderSubTitle, Footer } from "./styled/styles"
import { Link } from "gatsby"

const Layout = ({ children, theme, expanded }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div style={{ backgroundColor: theme.background }}>
      <Header siteTitle={data.site.siteMetadata.title} />
      <Helmet
        title={data.site.siteMetadata.title}
        description={data.site.siteMetadata.description}
        meta={[
          { name: "description", content: "Catalyst Black Wiki" },
          { name: "keywords", content: "catalystblack, wiki, catalystblackwiki, catalystblack wiki, cbwiki, cb" },
          { property: "og:image", content: "https://i.imgur.com/iWdPZqm.png" },
          { name: "viewport", content: "width=device-width, initial-scale=1.0, viewport-fit=cover" },
        ]}
      >
        <meta name="title" content="CBWiki" />
        <meta name="description" content="A Catalyst Black Wiki" />

        <meta name="keywords" content="catalystblack, wiki, catalystblackwiki, catalystblack wiki, cbwiki, cb" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="CBWIKI" />
        <meta property="og:description" content="A Catalyst Black Wiki" />
        <meta property="og:image" content="https://i.imgur.com/iWdPZqm.png" />
        <meta property="og:url" content="https://cbwiki.netlify.app/" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cbwiki.netlify.app/" />
        <meta property="twitter:title" content="CBWIKI" />
        <meta property="twitter:description" content="A Catalyst Black Wiki" />
        <meta property="twitter:image" content="https://i.imgur.com/iWdPZqm.png" />
        <meta name="viewport" content="initial-scale=1, viewport-fit=cover" />
        <html lang="en" />
      </Helmet>
      <div
        style={{
          margin: `auto`,
          maxWidth: 1300,
          paddingBottom: 100,
          fontFamily:
            "-apple-system, BlinkMacSystemFont,Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,Open Sans, Helvetica Neue, sans-serif",
        }}
      >
        <main>{children}</main>
        <Footer expanded={expanded}>
          <Link to="/semc">
            <HeaderSubTitle style={{ fontSize: 14, paddingBottom: "10px" }}>SECRET SEMC PAGE</HeaderSubTitle>
          </Link>
          <HeaderTitle>
            © {new Date().getFullYear()}, Built by Skillz4Killz. See a bug? Have an idea? Want to help? Contact me:{" "}
            <a href="https://discord.gg/J4NqJ72">
              <HeaderSubTitle style={{ fontSize: 14 }}>Discord</HeaderSubTitle>
            </a>
          </HeaderTitle>
        </Footer>
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
